import { Contractor } from "pmt-types/src/models/Contractor.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchContractors = () =>
  useMutationSearchEntities<Contractor>("contractors");
